export default Function.prototype.call.bind(Object.prototype.hasOwnProperty);
